import { createI18n } from 'vue-i18n';

const i18n = createI18n({
  legacy: false,
  fallbackLocale: 'en',
});

export default i18n;
